import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { message } from 'antd';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { getMyFileFullUrl } from '../../lib/utils';

class DownloadEpisode extends Component {
    downloadURI = () => {
        const { podcastEpisode, userDetails, myFiles } = this.props;
        if (!userDetails || !userDetails.uid) {
            message.warning('Please sign in to download episode.');
            return;
        }
        let uri = podcastEpisode.enclosure.link;
        if (myFiles[podcastEpisode.guid]) {
            uri = getMyFileFullUrl(myFiles[podcastEpisode.guid].enclosure.link);
        }
        const name = podcastEpisode.title;
        var link = document.createElement("a");
        // If you don't know the name or want to use
        // the webserver default set name = ''
        link.setAttribute('download', name);
        link.setAttribute('target', '_blank');
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    render() {
        // const { podcastEpisode } = this.props;
        return (
            <div onClick={this.downloadURI}><p className='mb-0'>
                <FontAwesomeIcon style={{ marginRight: '0px' }} icon='download' /> Download</p></div>
        )
    }
}

DownloadEpisode.propTypes = {
    podcastEpisode: PropTypes.any,
    userDetails: PropTypes.any,
    myFiles: PropTypes.object,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        myFiles: state.myFileEpisodes,
    }
}

// const mapDispatchToProps = (dispatch) => {
//     return {
//         setEpisodeAsPlayed: bindActionCreators(setEpisodeAsPlayed, dispatch),
//     }
// };

export default connect(mapStateToProps, null)(DownloadEpisode);